const companies = [
  {
    slug: 'golf-simulator',
    name: 'Golf4International Private Limited',
    description: 'Pioneering the future of golf through advanced simulation, professional training, and immersive digital experiences.',
    imageUrl: 'https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=2070&auto=format&fit=crop',
    services: [
      {
        title: 'Simulator',
        description: 'Providing world-class golf simulation solutions through advanced technology-driven platforms, enabling professional training, recreational engagement, tournament management, and immersive golfing experiences within controlled indoor environments.',
        imageUrl: 'https://images.pexels.com/photos/31212256/pexels-photo-31212256.jpeg?cs=srgb&dl=pexels-swingzone-swingzone-2150575315-31212256.jpg&fm=jpg',
        icon: '📊'
      },
      {
        title: 'Pro Shop',
        description: 'A premium golf retail and equipment division offering high-quality golf accessories, apparel, professional equipment, training aids, and customized golfing solutions to meet the requirements of beginners, enthusiasts, and professional golfers.',
        imageUrl: 'https://media.istockphoto.com/id/2190489125/photo/golf-equipment-display-with-polished-clubs-and-branded-apparel.jpg?s=612x612&w=0&k=20&c=9b35UDab3welPpsudHhh5hX8JUxXtHNMueXAxohMa74=',
        icon: '🛒'
      },
      {
        title: 'Academy',
        description: 'A professionally managed golf education and skill development platform focused on delivering structured coaching programs, performance enhancement training, talent nurturing, and player development under expert supervision.',
        imageUrl: 'https://www.marangaroogolf.com.au/wp-content/uploads/sites/28/2024/06/nathan-jennings-FmhOm8RjoW8-unsplash-scaled.jpg',
        icon: '🏌️'
      },
      {
        title: 'Mobile Game',
        description: 'Focused on the development and management of digital golf gaming ecosystems, offering engaging mobile-based gaming experiences, virtual tournaments, skill-based interaction, and user engagement through innovative technology solutions.',
        imageUrl: '/images/mobile_game.png',
        icon: '📱'
      }
    ]
  },
  {
    slug: 'nutrition',
    name: 'Heimdal Private Limited',
    description: 'Empowering individuals through holistic wellness and scientifically aligned nutritional solutions.',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=2080&auto=format&fit=crop',
    services: [
      {
        title: 'Herbal Life',
        description: 'Promoting health and wellness through premium nutrition and lifestyle enhancement solutions aimed at supporting fitness, balanced nutrition, preventive healthcare, and sustainable well-being.',
        imageUrl: '/images/herbal_life.png',
        icon: '🌿'
      },
      {
        title: 'Amura',
        description: 'Delivering scientifically aligned nutritional and wellness products designed to improve vitality, immunity, and overall health while promoting a balanced and performance-oriented lifestyle.',
        imageUrl: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?q=80&w=2053&auto=format&fit=crop',
        icon: '🍎'
      },
      {
        title: 'Brain Yoga',
        description: 'A specialized wellness initiative focused on cognitive enhancement, mental wellness, emotional balance, concentration improvement, and stress management through structured mind-development practices.',
        imageUrl: '/images/brain_yoga.png',
        icon: '🧘‍♂️'
      }
    ]
  },
  {
    slug: 'real-estate',
    name: 'SIF Real Estate Private Limited',
    description: 'Creating value through strategic property investments, development, and comprehensive real estate services.',
    imageUrl: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop',
    services: [
      {
        title: 'Property Sale',
        description: 'Facilitating professional real estate sales services across residential, commercial, and investment segments with a focus on market expertise, transparency, client satisfaction, and value-driven transactions.',
        imageUrl: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop',
        icon: '🏠'
      },
      {
        title: 'Property Purchase',
        description: 'Providing comprehensive property acquisition support, including advisory, evaluation, due diligence, negotiation, and documentation assistance to ensure secure and strategic investments.',
        imageUrl: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=1996&auto=format&fit=crop',
        icon: '🔑'
      },
      {
        title: 'Property Construction',
        description: 'Executing high-quality residential, commercial, and infrastructure development projects through professional planning, engineering excellence, project management, and timely delivery standards.',
        imageUrl: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2071&auto=format&fit=crop',
        icon: '🏗️'
      }
    ]
  },
  {
    slug: 'facilities-management',
    name: 'SIF Taxis Private Limited',
    description: 'Delivering excellence in operational efficiency and property management.',
    imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop',
    services: [
      {
        title: 'Facility',
        description: 'Delivering integrated facility management services encompassing operational efficiency, infrastructure maintenance, housekeeping, administrative support, and end-to-end property management solutions for corporate, commercial, and institutional establishments.',
        imageUrl: '/images/facility_management.png',
        icon: '🏢'
      },
      {
        title: 'Security',
        description: 'Providing professional security and surveillance solutions through trained personnel, risk mitigation strategies, safety compliance, access management, and comprehensive asset protection services.',
        imageUrl: '/images/security.png',
        icon: '🛡️'
      },
      {
        title: 'Other Services',
        description: 'Offering customized business support and operational services tailored to client-specific requirements, ensuring seamless execution, workforce optimization, and enhanced organizational productivity.',
        imageUrl: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?q=80&w=1974&auto=format&fit=crop',
        icon: '💼'
      }
    ]
  }
];

export default companies;
